import { inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

export function getGridSearchFormGroup(): FormGroup<{
  searchString: FormControl<string>;
}> {
  const formBuilder = inject(FormBuilder);
  return formBuilder.group({
    searchString: new FormControl<string>('', { nonNullable: true }),
  });
}